import React from 'react';
import { Slot } from 'react-page-layout';


export default function Simple() {
    return (
        <div className="modal--inner">
            <div className="modal--scroller">
                <div className="modal--content-wrapper">
                    <div className="modal--grid grid grid__condensed">
                        <div className="modal--container grid--container">
                            <Slot component="section" className="modal--content" name="content"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/modal/simple/index.js